<div *ngIf="type === 'chart'">
    <h2 mat-dialog-title class="dialog-title">
        📊 Graph
        <button mat-icon-button mat-dialog-close class="close-button" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </h2>

    <mat-dialog-content>
        <div class="graph-scroll-wrapper">
            <plotly-plot [data]="data.graph.data" [layout]="fullLayout"></plotly-plot>
        </div>
    </mat-dialog-content>
</div>

<div *ngIf="type === 'table'">
  <h2 mat-dialog-title class="dialog-title">
   📋 Report
    <button mat-icon-button mat-dialog-close class="close-button" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="dialog-scroll-content">
    <div class="scroll-container">
      <table class="report-table">
        <thead>
          <tr>
            <th *ngFor="let col of tableData?.columns">{{ col }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of tableData?.data">
            <td *ngFor="let col of tableData?.columns">
              <ng-container *ngIf="row[col].isImage; else textTemplate">
                <img [src]="row[col].value" alt="Image" width="60" height="60" />
              </ng-container>
              <ng-template #textTemplate>
                {{ row[col].value }}
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </mat-dialog-content>
</div>
